import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["hidden", "input", "arrow", "dropdown", "whiteSpace"];
    DATA = [];
    TYPE = "double";
    CURRENT_ACTIVE_INDEX = -1;

    connect()
    {
        this.setupDropdown(
            this.DATA,
            this.inputTarget,
            this.hiddenTarget,
            this.dropdownTarget,
            this.arrowTarget
        );
    }

    setupDropdown(optionData, inputField, hiddenField, dropdown, arrow)
    {
        optionData = Array.from(dropdown.children).map(option =>
        {
            this.TYPE = (option.children.length == 2) ? "double" : "single";

            let canon;
            if(option.dataset["customValue"] == "true" && this.TYPE != "single") canon = option.firstElementChild.textContent.trim();

            let name = (this.TYPE == "single") ? option.textContent.trim() : option.lastElementChild.textContent.trim();
            return {
                name,
                code: option.dataset["value"],
                canon
            }
        });

        this.addHideDropdownEL(dropdown, inputField, arrow);

        arrow.addEventListener("click", e => 
        {
            if (arrow.firstElementChild.style.transform == "rotate(360deg)" ||
                arrow.firstElementChild.style.transform == "rotate(0deg)")
            {
                this.resetOptions(optionData,
                    inputField, hiddenField, dropdown, arrow
                );

                this.showActiveElement(dropdown, inputField);

                this.openDropdown(dropdown, arrow, inputField);
            }
            else
            {
                this.closeDropdown(dropdown, arrow, inputField);
            }
        });

        Array.from(dropdown.children).forEach(option =>
            option.addEventListener("click", e => this.optionClickEventHandler(
                option, optionData, e,
                inputField, hiddenField,
                dropdown, arrow
            ))
        );

        inputField.addEventListener("focus", e =>
        {
            if(dropdown.classList.contains("toast-invisible"))
                arrow.click();

            this.showActiveElement(dropdown, inputField);
        })

        //Tabulation
        inputField.addEventListener("keydown", e =>
        {
            if(e.key == "Tab" || (e.key == "Tab" && e.shiftKey))
            {
                this.closeDropdown(dropdown, arrow, inputField);
                // if(inputField.value == "") this.CURRENT_ACTIVE_ITEM = -1;
            }
        })

        //Navigation with arrows
        inputField.addEventListener("keydown", e =>
        {
            if(e.key != "ArrowDown" && e.key != "ArrowUp") return;

            e.preventDefault();


            if(this.CURRENT_ACTIVE_INDEX != -1)
            {
                let currentElement = dropdown.children[this.CURRENT_ACTIVE_INDEX];
                currentElement.classList.remove("active");
            }

            if(e.key == "ArrowDown" && this.CURRENT_ACTIVE_INDEX != dropdown.children.length-1)
            {
                this.CURRENT_ACTIVE_INDEX++;
            }
            else if (e.key == "ArrowUp" && this.CURRENT_ACTIVE_INDEX > 0)
            {
                this.CURRENT_ACTIVE_INDEX--;
            }
        
            let caretPosition = inputField.value.length,
                nextElement = dropdown.children[this.CURRENT_ACTIVE_INDEX];

            let dropdownScroll = dropdown.scrollTop,
                yTopToTop = nextElement.getBoundingClientRect().y - dropdown.getBoundingClientRect().y,
                yBottomToBottom = nextElement.getBoundingClientRect().bottom - dropdown.getBoundingClientRect().bottom;

            if(yTopToTop < 0)
            {
                dropdown.scrollTo({top: dropdownScroll + yTopToTop, behavior: "smooth"})
            }
            else if (yBottomToBottom > 0)
            {
                dropdown.scrollTo({top: dropdownScroll + yBottomToBottom, behavior: "smooth"})
            }

            nextElement.classList.add("active");
            inputField.setSelectionRange(caretPosition, caretPosition)
            // inputField.value = selectedElement.lastElementChild.textContent;
            // hiddenField.value = selectedElement.dataset["value"];
        })

        //Escape
        inputField.addEventListener("keydown", e =>
        {
            if(e.key != "Escape") return;
            this.closeDropdown(dropdown, arrow, inputField);
        })

        //Enter
        inputField.addEventListener("keydown", e =>
        {
            if(e.key == "Enter" && !dropdown.classList.contains("toast-invisible"))
            {
                e.preventDefault();
                if(this.CURRENT_ACTIVE_INDEX != -1)
                {
                    let selectedElement = dropdown.children[this.CURRENT_ACTIVE_INDEX];
                    selectedElement.click();
                }
                else this.closeDropdown(dropdown, arrow, inputField);
            }
            else if (e.key == "Enter" && dropdown.classList.contains("toast-invisible"))
            {
                e.preventDefault();

                this.resetOptions(optionData,
                    inputField, hiddenField, dropdown, arrow
                );
                this.openDropdown(dropdown, arrow, inputField);
            }
        })

        inputField.addEventListener("input", e =>
        {
            let query = inputField.value.toLowerCase();
            hiddenField.value = query;

            this.CURRENT_ACTIVE_INDEX = -1;
            dropdown.scrollTo({ top:0, behavior: "smooth" })

            if (query == "")
            {
                hiddenField.value = "";
                    this.resetOptions(
                    optionData, inputField,
                    hiddenField, dropdown, arrow
                )

                return;
            }

            let filteredOptions = optionData.filter(option =>
            {
                return option.name.toLowerCase().includes(query) ||
                    option.code.toLowerCase().includes(query) ||
                    option.canon?.toLowerCase().includes(query)
            });

            if (filteredOptions.length == 0)
            {
                this.closeDropdown(dropdown, arrow, inputField);
                return;
            }

            let optionElements = filteredOptions.map(option => this.createOptionElement(
                option, optionData, inputField, hiddenField,
                dropdown, arrow
            ));

            dropdown.innerHTML = "";
            dropdown.append(...optionElements);
            dropdown.classList.remove("toast-invisible");
            inputField.style.borderBottomLeftRadius = "0";
            inputField.style.borderBottomRightRadius = "0";
        })

        inputField.addEventListener("focusout", e =>
        {
            let query = inputField.value;
            let option = optionData.find(group => group.name == query || group.code == query);

            hiddenField.value = (option) ? option.code : query;
        })
    }

    optionClickEventHandler(option, optionData, e, inputField, hiddenField, dropdown, arrow)
    {
        inputField.value = (this.element.dataset.onlyCode) ? option.dataset["value"] :
                           (this.TYPE == "single") ? option.innerText :
                           (option.dataset["customValue"] == "true") ? option.firstElementChild.innerText :
                           option.lastElementChild.innerText;
    
        hiddenField.value = option.dataset["value"];

        this.CURRENT_ACTIVE_INDEX = Array.from(dropdown.children).indexOf(option);

        this.closeDropdown(dropdown, arrow, inputField);
        setTimeout(() => this.resetOptions(
            optionData, inputField, hiddenField, dropdown, arrow
        ), 100);
    }

    createOptionElement(option, optionData, inputField, hiddenField, dropdown, arrow)
    {
        let div = document.createElement("div");
        div.classList.add("item");
        div.dataset.value = option.code;
        if(option.canon) div.dataset.customValue = true;

        div.innerHTML = (this.TYPE == "single") ? `<span>${option.name}</span>` : 
                                                    option.canon ? `<span>${option.canon}</span><span>${option.name}</span>` :
                                                    `<span>${option.code}</span><span>${option.name}</span>`;

        div.addEventListener("click", e => this.optionClickEventHandler(
            div, optionData, e,
            inputField, hiddenField, dropdown, arrow
        ));

        return div;
    }

    resetOptions(optionData, inputField, hiddenField, dropdown, arrow)
    {
        let options = optionData.map(option => this.createOptionElement(
            option, optionData, inputField, hiddenField, dropdown, arrow
        ));
        dropdown.innerHTML = "";
        dropdown.append(...options);
    }

    addHideDropdownEL(dropdown, textfield, arrow)
    {
        document.addEventListener("click", e =>
        {
            if (e.target == dropdown ||
                dropdown.contains(e.target) ||
                e.target == textfield ||
                arrow.contains(e.target)
            ) return;
            else this.closeDropdown(dropdown, arrow, textfield);
        })
    }

    openDropdown(dropdown, arrow, inputField)
    {
        arrow.firstElementChild.style.transform = "rotate(180deg)";
        dropdown.classList.remove("toast-invisible");

        inputField.classList.add("straight-corners");
        this.whiteSpaceTarget.classList.remove("hidden");

        // inputField.style.borderBottomLeftRadius = "0";
        // inputField.style.borderBottomRightRadius = "0";

        if(this.CURRENT_ACTIVE_INDEX != -1)
        {
            let selectedElement = dropdown.children[this.CURRENT_ACTIVE_INDEX];
            selectedElement.classList.add("active");
        }
    }

    closeDropdown(dropdown, arrow, inputField)
    {
        dropdown.classList.add("toast-invisible");
        arrow.firstElementChild.style.transform = "rotate(0deg)";

        inputField.classList.remove("straight-corners");
        this.whiteSpaceTarget.classList.add("hidden");

        // inputField.style.borderBottomLeftRadius = "";
        // inputField.style.borderBottomRightRadius = "";
    }

    showActiveElement(dropdown, inputField)
    {
        if(inputField.value && this.CURRENT_ACTIVE_INDEX == -1)
        {
            let value = inputField.value;
            let index = Array.from(dropdown.children).findIndex(el => this.TYPE == "single" ? 
                el.textContent == value : el.lastElementChild.textContent == value
            )

            if(index >= 0)
            {
                this.CURRENT_ACTIVE_INDEX = index;
                let active = dropdown.children[this.CURRENT_ACTIVE_INDEX];

                active.classList.add("active");

                let dropdownScroll = dropdown.scrollTop,
                    yBottomToBottom = active.getBoundingClientRect().bottom - dropdown.getBoundingClientRect().bottom;

                dropdown.scrollTo({top: dropdownScroll + yBottomToBottom, behavior: "smooth"})
            }
        }
    }
}